export const TRIAL = 'trial';
export const STATUSES = {
  ACTIVE: 'active'
};
export const dayExpression = days => days === 1 ? 'DAY_SINGULAR_EXPRESSION' : 'DAY_PLURAL_EXPRESSION';
//# sourceMappingURL=consts.js.map